enum EBankCode {
  BB = '001',
  SANTANDER = '033',
  INTER = '077',
  CAIXA = '104',
  BRADESCO = '237',
  NUBANK = '260',
  VOTORANTIM = '655',
  ITAU = '341',
  ITAU_PERSONALITTE = '479',
  HSBC = '399',
  CITIBANK = '477',
  CITIBANK_SECONDARY = '745',
  WARREN = '371'
}

export interface TGetCustomerSummaryResponse {
  id: string;
  name: string;
  mobile: string;
  document: string;
  availableBalance: number;
  totalGrossEarnings: number;
  totalGrossBalance: number;
  sinacorCustomerId: string;
  tradeGrossBalance: number;
  totalPortfolioGrossBalance: number;
  investmentAccountNetBalance: number;
  accountInfo: IAccountInfo;
  email: string;
}

export interface TGetLeadSummaryResponse {
  email: string;
  name: string;
  mobile: string;
}

interface IAccountInfo {
  bankCode: EBankCode;
  agency: string;
  agencyDigit: string;
  account: string;
  accountDigit: string;
}

export enum TransactionTypes {
  Deposit = 'deposit',
  Invoice = 'invoice',
  Withdrawal = 'withdraw',
  Payment = 'payment',
  Transfer = 'transfer',
  ElliotTransfer = 'elliotTransfer',
  CashbackReinvestment = 'cashbackReinvestment'
}
